<template>
    <TransitionRoot as="template" :show="open">
      <Dialog class="relative z-50" @close="closeDialog">
        <TransitionChild
          as="template"
          enter="ease-out duration-300"
          enter-from="opacity-0"
          enter-to="opacity-100"
          leave="ease-in duration-200"
          leave-from="opacity-100"
          leave-to="opacity-0"
        >
          <div class="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity" />
        </TransitionChild>
  
        <div class="fixed inset-0 z-10 w-screen overflow-y-auto">
          <div class="flex min-h-full items-end justify-center p-4 text-center sm:items-center sm:p-0">
            <TransitionChild
              as="template"
              enter="ease-out duration-300"
              enter-from="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
              enter-to="opacity-100 translate-y-0 sm:scale-100"
              leave="ease-in duration-200"
              leave-from="opacity-100 translate-y-0 sm:scale-100"
              leave-to="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
            >
              <DialogPanel
                class="relative transform overflow-hidden rounded-lg bg-white px-8 pb-8 pt-6 text-left shadow-xl transition-all sm:my-8 sm:w-full lg:max-w-4xl sm:p-6"
              >
                <!-- Header -->
                <div class="flex justify-between items-start">
                  <h2 class="text-xl font-bold leading-9 tracking-tight text-gray-900">Editar Rota</h2>
                  <button
                    @click="closeDialog"
                    type="button"
                    class="text-gray-400 hover:text-gray-600 -mt-4"
                  >
                    <span class="sr-only">Fechar</span>
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      class="h-6 w-6"
                      fill="none"
                      viewBox="0 0 24 24"
                      stroke="currentColor"
                      stroke-width="2"
                    >
                      <path
                        stroke-linecap="round"
                        stroke-linejoin="round"
                        d="M6 18L18 6M6 6l12 12"
                      />
                    </svg>
                  </button>
                </div>
  
                <!-- Form -->
                <form class="flex flex-wrap gap-4" @submit.prevent="sendData" method="POST">
                    <div class="mt-4 space-y-6 w-full flex flex-col">
                      <!-- Responsáveis -->
                      <div class="w-full p-4 bg-gray-50 rounded-lg shadow-md">
                        <h3 class="text-lg font-semibold text-blue-700 mb-4">Responsáveis</h3>
                        <ul class="space-y-3">
                            <li 
                            v-for="responsavel in editData.responsaveis" 
                            :key="responsavel.responsavel_email" 
                            class="flex items-center justify-between p-3 bg-white rounded-lg shadow-sm border"
                            >
                            <span class="text-sm text-gray-800">{{ responsavel.responsavel_email }}</span>
                            <a 
                                @click.prevent="deleteData(responsavel.responsavel_email)" 
                                href="#" 
                                class="text-sm font-medium text-indigo-600 hover:text-indigo-900"
                            >
                              Remover
                            </a>
                          </li>
                        </ul>
                      </div>

                    <!-- Filtros da Rota -->
                    <div  class="w-full p-4 bg-gray-50 rounded-lg shadow-md">
                      <h3 class="text-lg font-semibold text-blue-700 mb-4">Filtros Aplicados</h3>
                      <div class="flex flex-wrap gap-2">
                        <span v-if="filtrosVisiveis.uf" class="text-xs bg-purple-100 text-purple-800 px-2 py-1 rounded">
                          UF: {{ filtrosVisiveis.uf.join(', ') }}
                        </span>
                        <span v-if="filtrosVisiveis.empresas" class="text-xs bg-blue-100 text-blue-800 px-2 py-1 rounded">
                          Empresas: {{ filtrosVisiveis.empresas.join(', ') }}
                        </span>
                        <span v-if="filtrosVisiveis.idade_min && filtrosVisiveis.idade_max" class="text-xs bg-green-100 text-green-800 px-2 py-1 rounded">
                          Idade: {{ filtrosVisiveis.idade_min }} a {{ filtrosVisiveis.idade_max }}
                        </span>
                        <span v-if="filtrosVisiveis.carreira" class="text-xs bg-yellow-100 text-yellow-800 px-2 py-1 rounded">
                          Carreira: {{ filtrosVisiveis.carreira }}
                        </span>
                        <span v-if="filtrosVisiveis.dependentes" class="text-xs bg-pink-100 text-pink-800 px-2 py-1 rounded">
                          Inclui Dependentes
                        </span>
                      </div>
                    </div>

                    <!-- Campo de Agendadores -->
                    <div class="mb-4">
                      <label for="agendadores" class="block text-sm font-medium text-gray-900">Adicionar Agendadores</label>
                      <select 
                        multiple
                        v-model="formData.agendadores" 
                        id="agendadores" 
                        name="agendadores" 
                        class="mt-2 block w-full rounded-md border border-gray-300 py-2 px-3 shadow-sm focus:border-indigo-500 focus:ring focus:ring-indigo-200 focus:ring-opacity-50"
                      >
                        <option v-for="agendador in agendadores" :key="agendador.email" :value="agendador.email">
                          {{ agendador.name }}
                        </option>
                      </select>
                    </div>
                    <!-- Botão de salvar -->
                    <div class="w-7/10 self-center">

                      <button
                        type="submit"
                        class="flex w-full justify-center rounded-md bg-indigo-600 px-4 py-2 text-white hover:bg-indigo-700"
                      >
                        Salvar Alterações
                      </button>
                    </div>
                  </div>
                </form>
              </DialogPanel>
            </TransitionChild>
          </div>
        </div>
      </Dialog>
    </TransitionRoot>
  </template>
<script>
import { Dialog, DialogPanel, TransitionChild, TransitionRoot } from '@headlessui/vue';

export default {
  name: 'AgendamentosEdit',
  async created() {
  },
  props: {
    open: {
      type: Boolean,
      required: true,
    },
    editData: {
      type: Object,
      required: true,
    },
    agendadores: {
      type: Array,
      required: true,
      default: () => [],
    },
  },
  data() {
    return {
      formData: {
        agendadores:[]
      },
      filtrosVisiveis: {},
    };
  },
  watch: {
    editData: {
      immediate: true, // Executa na primeira carga também
      deep: true,      // Garante que subníveis sejam observados
      handler(novoValor) {
        this.atualizarFiltrosVisiveis(novoValor.agendamento?.filtros || {});
      }
    }
  },
  methods: {
    closeDialog() {
      this.$emit('update-open', false);
    },
    sendData() {
      this.$emit('save', this.formData,this.editData.agendamento.id);
      console.log(this.formData)
    },
    deleteData(email){
      this.$emit('delete-data', email,this.editData.agendamento.id);
    },
     atualizarFiltrosVisiveis(filtros) {
      this.filtrosVisiveis = {};

      if (Array.isArray(filtros.uf) && filtros.uf.length) {
        this.filtrosVisiveis.uf = filtros.uf;
      }
      if (Array.isArray(filtros.empresas) && filtros.empresas.length) {
        this.filtrosVisiveis.empresas = filtros.empresas;
      }
      if (filtros.idade_min && filtros.idade_max) {
        this.filtrosVisiveis.idade_min = filtros.idade_min;
        this.filtrosVisiveis.idade_max = filtros.idade_max;
      }
      if (filtros.carreira) {
        this.filtrosVisiveis.carreira = filtros.carreira;
      }
      if (filtros.dependentes) {
        this.filtrosVisiveis.dependentes = true;
      }
      // ... adicione outros filtros conforme necessário
    },
    
  },
  components: {
    Dialog,
    DialogPanel,
    TransitionChild,
    TransitionRoot,
  },
};
</script>
  